import type { Container } from "pixi.js";
import type { NoteEffect, NoteEffectFrame } from "./types";

export class NoneEffect implements NoteEffect {
  constructor(_parent: Container) {}

  update(_frame: NoteEffectFrame): void {}

  isAnimating(): boolean {
    return false;
  }

  destroy(): void {}
}
